import { render } from "./BaseNavbar.vue?vue&type=template&id=ffd441bc"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"

import "./BaseNavbar.vue?vue&type=style&index=0&id=ffd441bc&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__